export default {
  TODAY: "today", // danes
  YESTERDAY: "yesterday", // včeraj
  RANGE: "range", // izberi obdobje
  CALENDAR: "calendar", // izberi na koledarju
}
